import {
  INSERT_SOCKET_MESSAGE,
  SURFER_STATE_CHANGED,
  SURFER_ADDRESS_CHANGED,
  MMU_CONNECTION_STATE_CHANGED,
  HYMOTSE_STARTED,
  HYMOTSE_CONNECTED,
} from 'src/app/redux/redux-types';

import { MMUConnectionStatus, SurferContext } from 'src/types/components/mmu.type';

export const insertSocketMessage = (message: string) => {
  return {
    type: INSERT_SOCKET_MESSAGE,
    payload: message,
  };
};

export const surferStateChanged = (payload: boolean | undefined) => {
  return {
    type: SURFER_STATE_CHANGED,
    payload,
  };
};

export const surferAddressChanged = (payload: SurferContext | undefined) => {
  return {
    type: SURFER_ADDRESS_CHANGED,
    payload,
  };
};

export const MMUStatusChanged = (payload: MMUConnectionStatus) => {
  return {
    type: MMU_CONNECTION_STATE_CHANGED,
    payload,
  };
};

export const hymotseStarted = (payload: boolean) => {
  return {
    type: 'HYMOTSE_STARTED',
    payload,
  };
};

export const hymotseConnected = (payload: boolean) => {
  return {
    type: HYMOTSE_CONNECTED,
    payload,
  };
};
